import script from "./Impressum.vue?vue&type=script&setup=true&lang=js"
export * from "./Impressum.vue?vue&type=script&setup=true&lang=js"

import "./Impressum.vue?vue&type=style&index=0&id=112e0d5c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-112e0d5c"]])

export default __exports__